// extracted by mini-css-extract-plugin
module.exports = {"grid":"ArtistIndexBanners-grid-2nsqj"};